import Commerce from '@chec/commerce.js';

export const commerce = new Commerce('pk_22006ea5723fabc4f91edb828154c2ff2faaaae59213b',true);
//works with `${}`
